/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useState} from "react";
import useSub from "./useSub.jsx";
import {useDidMount} from "./useDidMount.jsx";
import {Socket} from "../Socket.js";
import useCompareEffect from "./useCompareEffect.jsx";
import {Deployments} from "../Objects/Deployments.jsx";
import {Database} from "../APIClient.jsx";

function useDeployment(deploymentId) {
    const [deploymentInfo, setDeploymentInfo] = useState({})

    async function fetchData() {
        if (deploymentId === undefined || deploymentId === null) return
        let deployment = await Deployments(deploymentId).getInfo()
        setDeploymentInfo(deployment ?? {})
    }

    useDidMount(() => {
        fetchData()
    })

    useCompareEffect(() => {
        fetchData()
    }, [deploymentId])

    useSub(() => Database.table("Deployments", "app").onChange((change) => {
        let updated = Socket.applyChange([deploymentInfo], change)[0]
        setDeploymentInfo(updated ?? {})
    }, [{
        column: "indexKey", value: deploymentId
    }]), "liveDeploymentData")

    return deploymentInfo
}

export default useDeployment;